module.exports = {
	"FSUSA002EH": {
		"r": 0,
		"s": {
			"FOUSA00COA": 288,
			"FOUSA00CTW": 289,
			"FOUSA05HX7": 290
		}
	},
	"FS0000G7XW": {
		"r": 1,
		"s": {
			"F000015LRM": 361
		}
	},
	"FSUSA0A2WX": {
		"r": 17,
		"s": {
			"F00000Q6Z5": 370,
			"F000003WZF": 367
		}
	},
	"FSUSA0028M": {
		"r": 17,
		"s": {
			"F00000Q6Z6": 369,
			"FOUSA00EVW": 366
		}
	},
	"FSUSA0001U": {
		"r": 17,
		"s": {
			"F00000Q6Z8": 368,
			"FOUSA00B44": 365
		}
	},
	"FS0000BRL1": {
		"r": 17,
		"s": {
			"F00000VKBH": 300
		}
	},
	"FS0000DDB3": {
		"r": 14,
		"s": {
			"F00000ZAXE": 360
		}
	},
	"FSUSA000AW": {
		"r": 11,
		"s": {
			"FOUSA00BJN": 40,
			"FOUSA00BOD": 42,
			"FOUSA00GMK": 43
		}
	},
	"FSUSA000AY": {
		"r": 11,
		"s": {
			"FOUSA00BJP": 44,
			"FOUSA02T8J": 46,
			"FOUSA00GPO": 47
		}
	},
	"FSUSA06ABB": {
		"r": 11,
		"s": {
			"FOUSA05BZB": 54,
			"FOUSA05BZC": 55
		}
	},
	"FSUSA067GL": {
		"r": 11,
		"s": {
			"FOUSA05BFM": 234,
			"F00000VA3L": 235
		}
	},
	"FS00009OF6": {
		"r": 0,
		"s": {
			"F00000ONCW": 257,
			"F00000ONCV": 258,
			"F00000ONCU": 259
		}
	},
	"FSUSA000AZ": {
		"r": 11,
		"s": {
			"FOUSA00BJQ": 60,
			"FOUSA00EX7": 62,
			"FOUSA00G1X": 63
		}
	},
	"FS0000AXHE": {
		"r": 11,
		"s": {
			"F00000TX0X": 225,
			"F00000TX0Y": 226,
			"F00000TX10": 227
		}
	},
	"FSUSA08B3D": {
		"r": 11,
		"s": {
			"FOUSA06ILL": 65,
			"FOUSA06ILN": 249,
			"FOUSA06ILO": 68
		}
	},
	"FSUSA098CG": {
		"r": 11,
		"s": {
			"FOUSA07ZRY": 69,
			"FOUSA07ZRZ": 70,
			"FOUSA07ZS1": 264
		}
	},
	"FS0000AA69": {
		"r": 11,
		"s": {
			"F00000Q87D": 222,
			"F00000Q87F": 223
		}
	},
	"FSUSA06CHS": {
		"r": 11,
		"s": {
			"FOUSA05C5X": 20,
			"FOUSA05C5Y": 39
		}
	},
	"FSUSA00DL2": {
		"r": 11,
		"s": {
			"FOUSA068B8": 237,
			"F00000NARV": 238,
			"FOUSA02TR5": 239
		}
	},
	"FSUSA000AU": {
		"r": 11,
		"s": {
			"FOUSA00BJK": 229,
			"FOUSA02T8C": 230,
			"FOUSA00GED": 231
		}
	},
	"FSUSA000AI": {
		"r": 11,
		"s": {
			"FOUSA00BJ4": 72,
			"FOUSA00DOX": 74,
			"FOUSA02SM2": 75
		}
	},
	"FSUSA08B3C": {
		"r": 11,
		"s": {
			"FOUSA06ILJ": 79,
			"FOUSA06ILK": 77
		}
	},
	"FSUSA000TL": {
		"r": 11,
		"s": {
			"FOUSA00HOS": 53,
			"FOUSA00CHG": 49,
			"FOUSA00CH3": 51
		}
	},
	"FSUSA06ABA": {
		"r": 11,
		"s": {
			"FOUSA05BZ7": 80,
			"FOUSA05BZA": 81
		}
	},
	"FSUSA000B7": {
		"r": 11,
		"s": {
			"FOUSA00BK3": 236,
			"F00000W2OY": 285,
			"F00000W2P0": 286
		}
	},
	"FSUSA00E70": {
		"r": 11,
		"s": {
			"FOUSA02UBA": 241,
			"FOUSA04ACQ": 242,
			"FOUSA04AFD": 243
		}
	},
	"FSUSA06531": {
		"r": 11,
		"s": {
			"FOUSA05B7A": 83,
			"FOUSA05BZ9": 85,
			"FOUSA05BZ6": 86
		}
	},
	"FSUSA002Y7": {
		"r": 11,
		"s": {
			"FOUSA007GA": 90,
			"FOUSA007W9": 89,
			"FOUSA005BX": 87
		}
	},
	"FSUSA07430": {
		"r": 11,
		"s": {
			"FOUSA05ILT": 245,
			"FOUSA05ILW": 246
		}
	},
	"FS0000BOXA": {
		"r": 11,
		"s": {
			"F00000VCX3": 271,
			"F00000VCX5": 275
		}
	},
	"FS0000BOXB": {
		"r": 11,
		"s": {
			"F00000VCX6": 272,
			"F00000VCX9": 278
		}
	},
	"FS0000C13N": {
		"r": 11,
		"s": {
			"F00000W59B": 372
		}
	},
	"FS0000BN1J": {
		"r": 18,
		"s": {
			"F00000V8KX": 266
		}
	},
	"null": {
		"r": 0,
		"s": {
			"null": 324
		}
	},
	"FSUSA07L1X": {
		"r": 15,
		"s": {
			"F00000P7Q9": 180,
			"FOUSA05XUR": 91
		}
	},
	"FSUSA004SD": {
		"r": 15,
		"s": {
			"FOUSA00AP7": 92,
			"F00000NE37": 175
		}
	},
	"FSUSA000KS": {
		"r": 15,
		"s": {
			"FOUSA08N2G": 93,
			"FOUSA00C3Q": 94,
			"FOUSA058NI": 95
		}
	},
	"FS0000FK68": {
		"r": 2,
		"s": {
			"F0000143T8": 358
		}
	},
	"FS0000ID7E": {
		"r": 16,
		"s": {
			"F00001GL0G": 330
		}
	},
	"FSUSA0014V": {
		"r": 12,
		"s": {
			"FOUSA00CZK": 26
		}
	},
	"FSUSA00DLL": {
		"r": 8,
		"s": {
			"FOUSA00DNP": 101
		}
	},
	"FS0000CMM8": {
		"r": 8,
		"s": {
			"F00000XGOT": 305,
			"F00000XGOS": 304
		}
	},
	"FS0000CBLE": {
		"r": 19,
		"s": {
			"F00000WRWF": 301,
			"F00000WRWH": 302
		}
	},
	"FSUSA000GZ": {
		"r": 20,
		"s": {
			"FOUSA00BV7": 28,
			"F000002N6T": 103,
			"FOUSA00GMX": 104,
			"F000002N72": 105,
			"F000002N6P": 106,
			"FOUSA05HC3": 107
		}
	},
	"FSUSA001RK": {
		"r": 17,
		"s": {
			"FOUSA00E3Q": 320,
			"F00000TWPI": 322
		}
	},
	"FSUSA001WD": {
		"r": 0,
		"s": {
			"FOUSA00ECB": 29
		}
	},
	"FSUSA001WE": {
		"r": 0,
		"s": {
			"FOUSA00ECC": 108
		}
	},
	"FS0000HWTE": {
		"r": 0,
		"s": {
			"F00001EKU4": 378
		}
	},
	"FSUSA06P37": {
		"r": 0,
		"s": {
			"FOUSA05H1T": 110
		}
	},
	"FSUSA001XC": {
		"r": 0,
		"s": {
			"FOUSA00EE5": 109
		}
	},
	"FSUSA06P39": {
		"r": 0,
		"s": {
			"FOUSA05H1V": 112
		}
	},
	"FS0000CSRW": {
		"r": 4,
		"s": {
			"F00000XUNO": 312,
			"F00000XUNN": 313
		}
	},
	"FSUSA002BA": {
		"r": 9,
		"s": {
			"FOUSA00F0H": 129,
			"FOUSA05GUH": 130
		}
	},
	"FS0000CSRX": {
		"r": 6,
		"s": {
			"F00000XUP9": 310,
			"F00000XUNP": 311
		}
	},
	"FSUSA0034E": {
		"r": 7,
		"s": {
			"F00000PWG1": 194,
			"FOUSA00GPU": 117,
			"FOUSA06BX8": 118
		}
	},
	"FSUSA08NBE": {
		"r": 7,
		"s": {
			"FOUSA06OGH": 114,
			"FOUSA06OGI": 115,
			"F00000PWG4": 193
		}
	},
	"FSUSA004U1": {
		"r": 5,
		"s": {
			"FOUSA00ATO": 120,
			"FOUSA05BXN": 121,
			"F00000PWG2": 195
		}
	},
	"FS0000CSRV": {
		"r": 4,
		"s": {
			"F00000XUNM": 306,
			"F00000XUNL": 307
		}
	},
	"FSUSA09MFM": {
		"r": 3,
		"s": {
			"F00000SFVV": 123,
			"FOUSA08NO8": 124
		}
	},
	"FSUSA08NBD": {
		"r": 5,
		"s": {
			"FOUSA06OGE": 126,
			"FOUSA06OGF": 127,
			"F00000PWG3": 196
		}
	},
	"FSUSA001XO": {
		"r": 5,
		"s": {
			"FOUSA00EEM": 31,
			"FOUSA06BX6": 113
		}
	},
	"FS0000FK69": {
		"r": 2,
		"s": {
			"F0000143TB": 359
		}
	},
	"FS0000G1L0": {
		"r": 2,
		"s": {
			"F0000158FY": 357
		}
	},
	"FSUSA001LH": {
		"r": 2,
		"s": {
			"FOUSA00DS2": 356
		}
	},
	"FSUSA001ZI": {
		"r": 2,
		"s": {
			"FOUSA00EH6": 353
		}
	},
	"FSUSA004DN": {
		"r": 13,
		"s": {
			"FOUSA009IY": 265
		}
	},
	"FSUSA0A4D5": {
		"r": 17,
		"s": {
			"F000003YRW": 143
		}
	},
	"FSUSA0A4D4": {
		"r": 17,
		"s": {
			"F000003YRV": 144
		}
	},
	"FSUSA0A4D6": {
		"r": 17,
		"s": {
			"F000003YRX": 145
		}
	},
	"FSUSA07YQW": {
		"r": 17,
		"s": {
			"FOUSA06B33": 146,
			"FOUSA06B2Z": 147
		}
	},
	"FSUSA000KC": {
		"r": 17,
		"s": {
			"FOUSA05I13": 148,
			"FOUSA00J14": 149
		}
	},
	"FSUSA0B43H": {
		"r": 17,
		"s": {
			"F00000JXN4": 152,
			"F00000JXN5": 153
		}
	},
	"FSUSA07YQX": {
		"r": 17,
		"s": {
			"FOUSA06B34": 154,
			"FOUSA06B31": 155
		}
	},
	"FSUSA00E3A": {
		"r": 17,
		"s": {
			"FOUSA05I17": 156,
			"FOUSA02U8F": 157
		}
	},
	"FSUSA07YWB": {
		"r": 16,
		"s": {
			"FOUSA08MZX": 3,
			"FOUSA06B5C": 10
		}
	},
	"FS0000BMMQ": {
		"r": 17,
		"s": {
			"F00000V7L7": 280
		}
	},
	"FS0000BMMP": {
		"r": 17,
		"s": {
			"F00000V7L6": 281
		}
	},
	"FS0000H0U8": {
		"r": 16,
		"s": {
			"F00001B6VM": 364
		}
	},
	"FS00009OB8": {
		"r": 22,
		"s": {
			"F00000ON4Y": 187,
			"F00000ON4Z": 203,
			"F00000ON50": 204,
			"F00000ON51": 202
		}
	},
	"FSUSA00I37": {
		"r": 23,
		"s": {
			"FOUSA02VJF": 205,
			"F000003V0P": 34,
			"FOUSA05HAJ": 135,
			"FOUSA04APD": 136
		}
	},
	"FS0000BVP7": {
		"r": 0,
		"s": {
			"F00000VTRN": 292
		}
	},
	"FS0000H5N2": {
		"r": 16,
		"s": {
			"F00001CRFU": 379
		}
	},
	"FSUSA0048E": {
		"r": 0,
		"s": {
			"FOUSA00JP6": 185
		}
	},
	"FSUSA003I4": {
		"r": 0,
		"s": {
			"FOUSA00HRA": 182
		}
	},
	"FS00008L9F": {
		"r": 0,
		"s": {
			"F00000MNAM": 184
		}
	},
	"FS00008TLS": {
		"r": 21,
		"s": {
			"F00000N2G9": 183
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/UssifFundsDiversityEeo.json
// module id = 935
// module chunks = 0